import posthog from 'posthog-js'
import { POSTHOG_APIKEY } from '../config'

let app = null

export const getPosthog = () => {
  if (app === null) {
    // Initialize if not already
    posthog.init(POSTHOG_APIKEY, {
      api_host: 'https://app.posthog.com'
    })
    app = posthog
  }

  return app
}
